export default "__VITE_ASSET__DMy3iJRn__"